module.exports = __webpack_public_path__ + "static/img/order-yqx.a2e0d59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order-yqx.png
// module id = 4lK3
// module chunks = 1